import React from "react";
const SVG=()=>{
  return(<svg width="24px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>Supplier_Supplier</title>
    <g id="00---Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Collapsed-Menu" transform="translate(-29.000000, -337.000000)" fill="#B3D4F5">
            <g id="vendor" transform="translate(0.000000, 320.000000)">
                <g id="Group" transform="translate(28.000000, 16.000000)">
                    <g id="Icon/Product/Home/Default/16-" transform="translate(1.000000, 1.000000)">
                        <path d="M5.74936997,0.5 L5.74936997,7.71819873 L13.624685,3.12468499 L13.624685,7.71819873 L21.5,3.12468499 L21.5,21.5 L0.5,21.5 L0.5,0.5 L5.74936997,0.5 Z M4.47116818,2.0138913 L2,2.0138913 L2,20 L20,20 L20,5.72657817 L12.2977069,10.2244352 L12.2977069,5.52166542 L4.47116818,10.2244352 L4.47116818,2.0138913 Z" id="Icon-Color"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  )
}
export default SVG;